export default __webpack_public_path__ + "static/media/4040page.a5ba6d69.jpg";